<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
    <path
      d="M4.333 4.333V2.667a1.667 1.667 0 1 0-1.666 1.666h1.666Zm0 0h3.334m-3.334 0v3.334m3.334-3.334h1.666a1.667 1.667 0 1 0-1.666-1.666v1.666Zm0 0v3.334m0 0v1.666a1.667 1.667 0 1 0 1.666-1.666H7.667Zm0 0H4.333m0 0H2.667a1.667 1.667 0 1 0 1.666 1.666V7.667Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
